<template>
  <v-card flat>
    <v-autocomplete box multiple clearable chips :menu-props="{maxHeight: 450}" label="Station Location" v-model="selectedLocations" :items="stationNames" @change="handleUpdateFilters"></v-autocomplete>
  </v-card>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'

  import {
    LocationFilter,
  } from '@/components/plugins/DataSetFilter'
  
  import {
    SOURCE_TYPES,
  } from '@/store/MonitoringFeature/monitoringfeature'

  const datasetfilter = createNamespacedHelpers('datasetfilter')  
  const dataSources = createNamespacedHelpers('datasource')

  export default {
    data() {
      return {
        selectedLocations: [],
      }
    },
    computed: {      
      ...dataSources.mapGetters(['dataSources']),
      ...datasetfilter.mapGetters(['getFilter']),
      discreteStations() {
        return this.dataSources[SOURCE_TYPES.discreteEnvirodata]
      },
      stationNames() {
        return this.discreteStations && this.discreteStations.map(ds => ds.LocationIdentifier)
      },
      selectedLocationsFromStore() {
        return this.getFilter('location').map(f => f.toString())
      },
    },
    watch: {
      selectedLocationsFromStore(newLocationList) {
        this.selectedLocations = newLocationList
      },
    },
    methods: {
      ...datasetfilter.mapActions(['updateFilterListByType']),
      handleUpdateFilters(filterStrings) {
        let filterList = filterStrings.map(f => new LocationFilter(f))
        this.updateFilterListByType({
          filterType: 'location',
          filters: filterList,
        })
        this.$emit('instantSearchEvent', 'location')
      },
      handleReturn() {
        this.reset()
        this.$emit('returnEvent', 'location')
      },
      reset() {
        this.selectedLocations = []
      },
    },
    beforeMount() {
      this.selectedLocations = this.selectedLocationsFromStore
    },
  }
</script>
